import { FaTrashAlt } from "react-icons/fa";
import { useGroupManager } from "../../hooks/useGroupManager";

export default function GroupItem({ groups, groupKey }) {
  const { handleDeleteGroup } = useGroupManager();
  return (
    <>
      <div className="flex px-2 py-1 mt-2 w-full">
        <p className="border px-2 py-1 border-black w-[90%] bg-white rounded">
          {groupKey}
        </p>
        <button
          className="bg-white border px-2 py-1 border-black rounded hover:bg-gray-400"
          onClick={() => handleDeleteGroup(groups[groupKey].id)}
        >
          <FaTrashAlt className="text-red-600" />
        </button>
      </div>
    </>
  );
}
